module.exports = {"370613001":"黄海路街道","370613002":"初家街道","370613003":"滨海路街道","370613004":"解甲庄街道","370613005":"莱山街道","370613006":"院格庄街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370613.json
// module id = 1293
// module chunks = 0